import CONTRATO_ESCALATORIAS from '@/graphql/querys/administracion/contratos/escalatorias/contratoEscalatorias.gql';
import AGREGAR_CONTRATO_ESCALATORIA from '@/graphql/mutations/administracion/contratos/contrato/escalatorias/agregarContratoEscalatoria.gql';
import ACTUALIZAR_CONTRATO_ESCALATORIA from '@/graphql/mutations/administracion/contratos/contrato/escalatorias/actualizarContratoEscalatoria.gql';
import REMOVER_CONTRATO_ESCALATORIA from '@/graphql/mutations/administracion/contratos/contrato/escalatorias/removerContratoEscalatoria.gql';

export default {
  methods: {
    async mixRegistrarEscalatoria() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_ESCALATORIA,
          variables: {
            escalatoria: this.escalatoria,
          },
          update: (store, { data: { agregarContratoEscalatoria } }) => {
            const query = {
              query: CONTRATO_ESCALATORIAS,
              variables: {
                idContrato: this.idContrato,
              },
            };
            const { contratoEscalatorias } = store.readQuery(query);
            const contratoEscalatoriasCopia = contratoEscalatorias.slice();
            contratoEscalatoriasCopia.push(agregarContratoEscalatoria);
            store.writeQuery({
              ...query,
              data: {
                contratoEscalatorias: contratoEscalatoriasCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.enviandoFormulario = false;
      this.cerrar();
    },
    async mixActualizarEscalatoria() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_ESCALATORIA,
          variables: {
            id: this.escalatoriaEditar.id,
            escalatoria: this.escalatoria,
          },
          update: (store, { data: { actualizarContratoEscalatoria } }) => {
            const query = {
              query: CONTRATO_ESCALATORIAS,
              variables: {
                idContrato: this.escalatoriaEditar.idContrato,
              },
            };
            const { contratoEscalatorias } = store.readQuery(query);
            const index = contratoEscalatorias
              .findIndex(({ id }) => id === this.escalatoriaEditar.id);
            if (index !== -1) {
              contratoEscalatorias.splice(index, 1, actualizarContratoEscalatoria);
            }
            store.writeQuery({
              ...query,
              data: {
                contratoEscalatorias,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
      this.enviandoFormulario = false;
      this.cerrar();
    },

    async mixEliminarEscalatoria() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_ESCALATORIA,
        variables: {
          id: this.contratoEscalatoriaEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_ESCALATORIAS,
            variables: {
              idContrato: this.contratoEscalatoriaEliminar.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { contratoEscalatorias } = data;
          const index = contratoEscalatorias
            .findIndex((escalatoria) => escalatoria.id === this.contratoEscalatoriaEliminar.id);
          if (index !== -1) {
            contratoEscalatorias.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
